var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path.indexOf('login')==-1)?_c('webmenu'):_vm._e(),_c('keep-alive',[_c('router-view')],1),(_vm.$route.path.indexOf('login')==-1)?_c('userinfor'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }